import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useBanners } from '@/app/hooks/useBanners'
import { BannerOrigin, BannerType } from '@/app/entities/Banner'
import { useEffect } from 'react'
import { useWhitelabelContext } from '@/app/contexts/whitelabelContext'
import { useNavigate } from 'react-router-dom'

const schema = z
  .object({
    email: z.string().min(1, 'E-mail ou CPF são obrigatório'),
    password: z.string().min(6, 'Senha deve conter pelo menos 6 dígitos'),
  })
  .transform(({ email, password }) => {
    const cpf = email.replace(/\D/g, '')

    if (cpf.length === 11 && email.match(/^\d/)) {
      return { cpf, password }
    }

    return { email, password }
  })

export type FormLoginData = z.infer<typeof schema>

export const useLoginController = () => {
  const { whitelabel, showCodeScreen } = useWhitelabelContext()
  const navigate = useNavigate()
  const methods = useForm<FormLoginData>({
    resolver: zodResolver(schema),
  })
  const { banners, isLoading } = useBanners(BannerType.LOGIN, BannerOrigin.WEB)

  useEffect(() => {
    if (showCodeScreen && !whitelabel) {
      navigate('/')
    }
  }, [navigate, showCodeScreen, whitelabel])

  return { methods, banners, isLoading }
}
